module.exports = __webpack_public_path__ + "img/attendance-base.15b12b1.png";